import { Browser as CapacitorBrowser } from "@capacitor/browser";

/**
 * Simplified wrapper around Capacitor Browser plugin Provides clean API for opening URLs in in-app
 * browser
 */
export const Browser = {
  open: (options: Parameters<typeof CapacitorBrowser.open>[0]) => CapacitorBrowser.open(options),
  close: () => CapacitorBrowser.close(),
  addListener: CapacitorBrowser.addListener.bind(CapacitorBrowser),
  removeAllListeners: () => CapacitorBrowser.removeAllListeners(),
};

export type * from "@capacitor/browser";
